<template>
<v-container>
  <v-card>
    <v-card-title>
      <strong>Menus</strong>
      <v-btn fab dark small color="#4EABDD" @click="insertNewRecord()">
        <v-icon dark>add</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field outline append-icon="search" label="Cerca" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search">
      <template slot="items" slot-scope="props">
        <tr @click="updateRecord(props.item.id)">
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left">
            <v-icon v-html="props.item.icona"></v-icon>
          </td>
          <td class="text-xs-left">{{ props.item.descrizione }}</td>
          <td class="text-xs-left">{{ props.item.route }}</td>
          <td class="text-xs-left">{{ props.item.href }}</td>
          <td class="text-xs-left">{{ props.item.ordine }}</td>
          <td class="text-xs-left">{{ props.item.appId }}</td>
        </tr>
      </template>
      <template
        slot="pageText"
        slot-scope="{ pageStart, pageStop }"
      >From {{ pageStart }} to {{ pageStop }}</template>
    </v-data-table>
  </v-card>
</v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      tmp: "",
      search: "",
      pagination: {},
      headers: [
        { text: "Id", align: "left", value: "id" },
        { text: "Icona", align: "left", value: "icona" },
        { text: "Descrizione", align: "left", value: "descrizione" },
        { text: "Route", align: "left", value: "route" },
        { text: "Url", align: "left", value: "href" },
        { text: "Ordine", align: "left", value: "ordine" },
        { text: "AppId", align: "left", value: "appId" }
      ],
      items: []
    };
  },
  created(){
    this.$store.dispatch("ImpostaScollegamento");
  },
  mounted() {
    this.CheckJWT();
    this.getDataFromService();
  },
  methods: {
    getDataFromService() {
      this.loading = true;
      axios.get(this.$store.state.servicePath + "/api/ArMenus").then(res => {
        this.items = res.data;
        //console.log(this.items)
        this.loading = false;
      });
    },

    insertNewRecord() {
      this.$router.push({ path: `/menus/0` });
    },

    updateRecord(recid) {
      this.$router.push({ path: `/menus/${recid}` });
    },
    CheckJWT() {
      axios
        .post(this.$store.state.servicePath + "/api/Login/checkJwt", {
          route: this.$route.path
        })
        .then(res => {
          if (res.data.status == "ko") {
            this.$router.push({ path: `/errore` });
          }
        })
        .catch(err =>{
          this.$router.push({ path: `/errore` });
        });
    }
  }
};
</script>